
import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const translations = {
  en: {
    companyName: "The Horn Educational Network",
    title: "Empowering Minds,",
    subtitle: "Bridging Horizons",
    description: "Your gateway to world-class education in Malaysia and the UK. Get up to 50% scholarship and comprehensive support throughout your academic journey.",
    apply: "Apply Now",
    consultation: "Book Free Consultation",
    intake: "Next Intake: February & September 2025"
  },
  // ... other translations
};

function Hero({ language, onApplyClick, onConsultClick }) {
  const content = translations[language];

  return (
    <div className="relative min-h-[calc(100vh-5rem)] flex items-center hero-pattern">
      <div className="container mx-auto px-4 py-20">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6">
              {content.companyName}
            </h1>
            <div className="mb-8">
              <h2 className="text-3xl md:text-4xl font-bold">
                {content.title}
                <br />
                <span className="gradient-text">{content.subtitle}</span>
              </h2>
            </div>
            <p className="text-lg text-muted-foreground mb-8">
              {content.description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="group apply-button"
                onClick={onApplyClick}
              >
                {content.apply}
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="consultation-button"
                onClick={onConsultClick}
              >
                {content.consultation}
              </Button>
            </div>
            <p className="mt-6 text-sm text-muted-foreground">
              {content.intake}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            <div className="aspect-video rounded-lg overflow-hidden shadow-2xl">
              <img  
                alt="Students studying at a modern university campus" 
                className="w-full h-full object-cover"
               src="https://images.unsplash.com/photo-1677730277400-097e5da58a56" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-accent/10 backdrop-blur-sm rounded-lg p-6 shadow-lg">
              <div className="flex items-center gap-4">
                <div className="bg-accent rounded-full p-3">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="font-semibold">500+</p>
                  <p className="text-sm text-muted-foreground">Students Placed</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
